"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetcher = exports.Fetcher = void 0;
var next_api_error_1 = require("@newfront-insurance/next-api-error");
var js_cookie_1 = __importDefault(require("js-cookie"));
/**
 * The default fetcher for making requests to the Next API. This uses the bog-standard fetch method. This can be
 * replaced in tests with something that is a bit more testable, like Axios.
 */
var Fetcher = /** @class */ (function () {
    function Fetcher(options) {
        if (options === void 0) { options = {}; }
        this.baseUrl = options.baseUrl || '';
        this.xsrfHeaderName = options.xsrfHeaderName || 'X-XSRF-TOKEN';
        this.xsrfCookieName = options.xsrfCookieName || 'XSRF-TOKEN';
        this.token = options.token || '';
    }
    Fetcher.prototype.request = function (options) {
        return __awaiter(this, void 0, void 0, function () {
            var url, body, method, authHeaders, res, data, error;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = options.url, body = options.body, method = options.method;
                        return [4 /*yield*/, this.getAuthHeaders()];
                    case 1:
                        authHeaders = _a.sent();
                        return [4 /*yield*/, fetch("" + this.baseUrl + url, {
                                headers: __assign({ 'Content-Type': 'application/json' }, authHeaders),
                                body: JSON.stringify(body),
                                method: method,
                            })];
                    case 2:
                        res = _a.sent();
                        return [4 /*yield*/, res.json()];
                    case 3:
                        data = _a.sent();
                        error = !res.ok
                            ? new next_api_error_1.NextApiError({
                                url: url,
                                method: method,
                                statusCode: res.status,
                                data: data,
                            })
                            : null;
                        if (error) {
                            return [2 /*return*/, { data: null, error: error }];
                        }
                        return [2 /*return*/, { data: data, error: null }];
                }
            });
        });
    };
    Fetcher.prototype.getAuthHeaders = function () {
        return __awaiter(this, void 0, void 0, function () {
            var headers, token, _a, xsrfToken;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        headers = {};
                        if (!(typeof this.token === 'function')) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.token()];
                    case 1:
                        _a = _b.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        _a = this.token;
                        _b.label = 3;
                    case 3:
                        token = _a;
                        if (token) {
                            headers.Authorization = "Bearer " + token;
                        }
                        xsrfToken = js_cookie_1.default.get(this.xsrfCookieName);
                        if (xsrfToken) {
                            headers[this.xsrfHeaderName] = xsrfToken;
                        }
                        return [2 /*return*/, headers];
                }
            });
        });
    };
    return Fetcher;
}());
exports.Fetcher = Fetcher;
exports.fetcher = new Fetcher();
